var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-time-7640071",
    d: "M224.529,291.183a.37.37,0,0,1-.356.378h-.627a.37.37,0,0,1-.356-.378V289.85a.357.357,0,1,1,.712,0v.945h.271a.37.37,0,0,1,.356.378Zm.237,3.826a.37.37,0,0,0-.356.378v4.745a1.057,1.057,0,0,1-1.025,1.089H209.131a1.057,1.057,0,0,1-1.025-1.089v-7.2h11.551a.377.377,0,0,0,.364-.378.371.371,0,0,0-.364-.378H208.105v-1.314a1.057,1.057,0,0,1,1.025-1.089h10.576a.377.377,0,0,0,.364-.378.371.371,0,0,0-.364-.378H209.131a1.8,1.8,0,0,0-1.746,1.855v9.283a1.8,1.8,0,0,0,1.746,1.855h14.254a1.8,1.8,0,0,0,1.746-1.855v-4.745a.37.37,0,0,0-.356-.378Zm-15.542-4.051a.416.416,0,1,0,.415-.441A.429.429,0,0,0,209.224,290.958Zm1.686,0a.416.416,0,1,0,.415-.441A.429.429,0,0,0,210.911,290.958Zm1.695,0a.416.416,0,1,0,.415-.441A.429.429,0,0,0,212.605,290.958Zm13.78-.027a2.759,2.759,0,1,1-2.754-2.926A2.85,2.85,0,0,1,226.385,290.931Zm-.771,0a1.978,1.978,0,1,0-1.975,2.1A2.041,2.041,0,0,0,225.614,290.931Z",
    transform: "translate(-207.385 -288.005)",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInTime);
export default __webpack_public_path__ + "static/media/checkInTime.64fe06557d6fe7a91d8ce617f15b7bf3.svg";
export { ForwardRef as ReactComponent };